document.addEventListener("DOMContentLoaded", (event) => {
  const subscriptionsUpdates = () => {
    const plansSelector = Array.from(
      document.querySelectorAll("[data-smartrr-selling-plan-group-id]")
    );
    const variantPicker = document.querySelector(".td-variant-picker");
    const checkmarksElement = document.querySelector(
      ".subscription_checkmarks"
    );
    const oneTimePlanElement = plansSelector.find(
      (p) => p.getAttribute("data-smartrr-selling-plan-group-id") == ""
    );
    const oneTimeDiscountTags = Array.from(
      document.querySelectorAll(".one-time-discount")
    );
    const planDiscountTags = Array.from(
      document.querySelectorAll(".subscription-discount")
    );
    const oneTimePlanPrice = oneTimePlanElement.querySelector(
      "[data-smartrr-subscribe-price]"
    );
    const atcButtonPriceWrapper = document.querySelector(
      ".td-atc-button .atc-price"
    );
    const firstProductTag = document.querySelector("[data-full-price]");
    const radios = Array.from(
      document.querySelectorAll("[data-smartrr-group-radio]")
    );
    const atcBtnCompare = document.querySelector(".atc-compare");
    // Adds element for compare at price
    if (oneTimePlanPrice) {
      oneTimePlanPrice.insertAdjacentHTML(
        "afterend",
        '<span class="one-time-compare"><span>'
      );
    }

    // Product Variants
    if (!variantPicker) return;

    const variantInputs = Array.from(
      variantPicker.querySelectorAll(".td-product-form__input input")
    );
    if (variantInputs.length) {
      variantInputs.map((input) => {
        const wrapper = input.closest(".product-form__variant-input");
        
       
        // On Variant Change
        input.addEventListener("change", function (e) {
          e.preventDefault();

          const oneTimeSelected = oneTimePlanElement.classList.contains(
            "smartrr-group-active"
          );
          
          const oneTimeComparePrice = this.dataset.oneCompare;
          const oneTimePrice = this.dataset.onePrice;
          const planCompareItem = this.dataset.planCompare;
          const planPrice = this.dataset.planPrice;
          const oneTimeCompareItem =
            document.querySelector(".one-time-compare");
          
          if (oneTimeCompareItem)
            oneTimeCompareItem.innerHTML = `${oneTimeComparePrice}`;
          

          if (oneTimeDiscountTags.length && planDiscountTags.length) {
            oneTimeDiscountTags.map((t) => t.classList.add("td-hidden"));
            planDiscountTags.map((t) => t.classList.remove("td-hidden"));
          }
          if (!oneTimeSelected && firstProductTag) {
            firstProductTag.classList.remove("tag-hidden");
          }

          if (atcButtonPriceWrapper) {
            atcButtonPriceWrapper.innerHTML = oneTimeSelected ? oneTimePrice : planPrice;
          }
          if(atcBtnCompare) {            
            atcBtnCompare.innerHTML = oneTimeSelected ? `${oneTimeComparePrice}` : `${planCompareItem}`;
          }
        });
      });
    }
    // Subscription plans
    if (plansSelector.length) {
      plansSelector.map((elem) => {
        const sellingPlan = elem.getAttribute(
          "data-smartrr-selling-plan-group-id"
        );
        // selling plan checkmarks
        if (sellingPlan) {
          const planLabel = elem.querySelector("label");
          if (planLabel && checkmarksElement) {
            planLabel.insertAdjacentHTML(
              "beforeend",
              checkmarksElement.outerHTML
            );
          }
        }
        const planInput = elem.querySelector("input");
        // On plan change
        planInput.addEventListener("change", function (e) {
         
          const oneTimePlanPrice = oneTimePlanElement.querySelector(
            "[data-smartrr-subscribe-price]"
          );
          const oneTimeSelected = oneTimePlanElement.classList.contains(
            "smartrr-group-active"
          );
          const planPrice = this.closest("label").querySelector(
            "[data-smartrr-subscribe-price]"
          );
          const selectedInput = variantInputs.find((i) => i.checked);
          const planComparePrice = selectedInput.dataset.planCompare;
          const oneTimeComparePrice = selectedInput.dataset.oneCompare;
          
          if(atcBtnCompare) {            
            atcBtnCompare.innerHTML = oneTimeSelected ? `${oneTimeComparePrice}` : `${planComparePrice}`;
          }
          if (oneTimeSelected) {
       
            if (oneTimeDiscountTags.length && planDiscountTags.length) {
              oneTimeDiscountTags.map((t) => t.classList.remove("td-hidden"));
              planDiscountTags.map((t) => t.classList.add("td-hidden"));
            }
            if (firstProductTag) {
              firstProductTag.classList.add("tag-hidden");
            }
            atcButtonPriceWrapper.innerHTML = oneTimePlanPrice.innerText;    
                 
          } else {
            if (oneTimeDiscountTags.length && planDiscountTags.length) {
              oneTimeDiscountTags.map((t) => t.classList.add("td-hidden"));
              planDiscountTags.map((t) => t.classList.remove("td-hidden"));
            }
            if (planPrice) {
              atcButtonPriceWrapper.innerHTML = planPrice.innerText;
            }
            if (firstProductTag) {
              firstProductTag.classList.remove("tag-hidden");
            }
          }
        });
      });
    }
  };
  subscriptionsUpdates();
});
